import { useFont } from '@octane/spark'
import { typography } from 'assets/styles'
import { decisionResultBanners } from 'branding/lender'
import LenderName from 'state/enums/LenderName'
import styled from 'styled-components'

export const MainContainer = styled.main`
    max-width: 825px;
    padding: 0;
    margin-top: 0;
    margin-bottom: 20px;
`

export const LoaderWrapper = styled.div`
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
`

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 1.6em;
`

export const LabelWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-top: 18px;
`

export const ApprovedTitle = styled.h2`
    ${typography.Hero36}
    color: ${({ theme }) => theme.colors.alert.success};
    text-transform: capitalize;
    margin-top: 0.5em;
    margin-bottom: 0em;
`

export const DeclinedTitle = styled.h2`
    ${typography.Hero36}
    color: ${({ theme }) => theme.colors.alert.warning};
    text-transform: capitalize;
    margin-top: 0.5em;
    margin-bottom: 0;
`

export const SubmittedTitle = styled.h2`
    ${typography.Hero36}
    color: ${({ theme }) => theme.colors.monochrome.jetlineBlack};
    text-transform: capitalize;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
`

export const BodyText = styled.span`
    ${() => useFont('c24', { weight: '400' })}
    margin-top: 0.1em;
    margin-bottom: 1em;
`

export const AprText = styled.div`
    ${() => useFont('c24', { weight: '400' })}
    margin-top: 0.1em;
`

export const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 1em;
    margin-top: 0.5em;
`

export const FinePrint = styled.div`
    ${() => useFont('c16', { weight: '400' })};
    color: ${(props) => props.theme.colors.monochrome.asphalt};
    margin-top: 1em;
    display: flex;
    justify-content: center;
`

export const FooterText = styled.div`
    margin-right: 0.3em;
`

export const RuleLine = styled.hr`
    border-bottom: 1px solid ${({ theme }) => theme.colors.monochrome.concrete};
    width: 100%;
    margin: 1em 0 1em 0;
`

export const DisclosureSpinnerWrapper = styled.div`
    margin-top: 1em;
`

export const DisclosureContainer = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    text-align: left;
    margin-top: 1em;
`

export const DisclosureTitle = styled.h4`
    ${() => useFont('c14', { weight: '800' })}
    margin-top: 0.7em;
    margin-bottom: 0.3em;
`

export const DisclosureParagraph = styled.p`
    ${() => useFont('c12', { weight: '400' })}
    margin-top: 0.7em;
    margin-bottom: 0;
`

export const ButtonWrapper = styled.div`
    width: 100%;
`

export const DetailContainer = styled.div`
    display: flex;
    justify-content: space-between;
    & > div {
        width: 100%;
    }
`
export const DetailField = styled.div`
    display: flex;
    padding-bottom: 0.3em;
`

export const DetailLabel = styled.div`
    ${() => useFont('c16', { weight: '400' })};
    color: ${(props) => props.theme.colors.monochrome.graphite};
    align-content: center;
    margin-right: 1em;
    width: 35%;
`
export const DetailInfo = styled.div`
    ${() => useFont('c16', { weight: '400' })};
    display: flex;
    margin-left: 0;
    width: 90%;
    gap: 1em;
    align-items: center;
    &:last-child {
        justify-content: end;
        align-items: center;
    }
`

export const TextWrapper = styled.div`
    font-weight: 700;

    &:last-child {
        font-weight: 500;
    }
`
export const HeaderField = styled.div`
    display: flex;
    justify-content: space-between;
    color: ${(props) => props.theme.colors.monochrome.ravenSub};
`
export const CollateralField = styled.div`
    display: flex;
    gap: 20px;

    &:first-child {
        min-width: 50px;
    }
`

export const CollateralInfo = styled.div`
    ${() => useFont('c16', { weight: '400' })};
    display: flex;
    align-items: center;
    gap: 5px;
    &:last-child {
        margin-left: auto;
    }
`

export const ReserveCalloutText = styled.span`
    ${() => useFont('c24', { weight: '400' })}
    color: ${({ theme }) => theme.colors.alert.success};
    margin-top: 0.5em;
    margin-bottom: 0;
`

export const LenderBanner = styled.img.attrs(
    ({ lenderName }: { lenderName: LenderName }) => ({
        src: decisionResultBanners[lenderName],
    }),
)`
    ${({ lenderName }: { lenderName: LenderName }) =>
        decisionResultBanners[lenderName] ? `display: block` : `display: none`};
    margin-top: 1em;
`
